<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0;">
            <div class="header-icon-wrap mr-3">
              <i class="fe fe-shuffle" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Add Referral</h4>
              <small style="opacity: 0.8;">Refer an enrollee to another facility</small>
            </div>
          </div>
        </div>
      </div>

      <section style="margin-top: -20px;">
        <div class="container pb-5">
          <div class="row">
            <div class="col-lg-10 col-md-12 mx-auto">
              <div class="card shadow form-card">
                <div class="form-card-header">
                  <div class="section-number">1</div>
                  <h6 class="mb-0 font-weight-bold text-white">Referral Details</h6>
                </div>

                <div class="card-body px-4 py-4">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label class="form-label">Enrollee RIVCHPP Number</label>
                      <input type="text" class="form-control" v-model="searchkey" @change="searchIDCard" />
                    </div>

                    <div class="form-group col-md-6">
                      <label class="form-label">Provisional Diagnosis</label>
                      <v-select v-model="referral.provisional_diagnosis" label="name"
                        :required="!referral.provisional_diagnosis" :options="diseases" />
                    </div>

                    <div class="form-group col-md-6">
                      <label class="form-label">Encounter Code</label>
                      <input type="text" class="form-control"
                        placeholder="Link referral to an encounter record of the patient"
                        v-model="referral.investigations" />
                    </div>

                    <div class="form-group col-md-6">
                      <label class="form-label">Recipient Facility</label>
                      <v-select v-model="referral.recipient_facility" label="agency_name"
                        :required="!referral.recipient_facility" :options="providers" />
                    </div>

                    <template v-if="search_result != ''">
                      <div class="form-group col-md-6">
                        <label class="form-label">Client Surname</label>
                        <input type="text" class="form-control" :value="search_result.data.firstname" disabled />
                      </div>
                      <div class="form-group col-md-6">
                        <label class="form-label">Client First Name</label>
                        <input type="text" class="form-control" :value="search_result.data.lastname" disabled />
                      </div>

                      <div class="form-group col-md-6">
                        <label class="form-label">Sex</label>
                        <input type="text" class="form-control" :value="search_result.data.gender" disabled />
                      </div>
                      <div class="form-group col-md-6">
                        <label class="form-label">Phone Number</label>
                        <input type="text" class="form-control" :value="search_result.data.phone_number" disabled />
                      </div>
                    </template>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label class="form-label">Clinical Findings/Treatment Given</label>
                      <textarea rows="6" class="form-control" v-model="referral.treatment_given"></textarea>
                    </div>
                    <div class="form-group col-md-12">
                      <label class="form-label">Reason for Referral</label>
                      <textarea rows="6" class="form-control" v-model="referral.reason"></textarea>
                    </div>
                  </div>

                  <div class="d-flex justify-content-end">
                    <button class="btn btn-submit" :disabled="isLoading" @click="AddReferral">
                      <span v-if="isLoading"><i class="mdi mdi-loading mdi-spin mr-1"></i>Submitting…</span>
                      <span v-else><i class="fe fe-send mr-1"></i>Submit</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            loader="dots"
            :can-cancel="true"
            :is-full-page="fullPage"
          ></loading>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      editor: ClassicEditor,
      user: null,
      searchkey: "",
      search_result: "",
      enrollee_details: "",
      randomvalue: "",
      providers: "",
      diseases: "",
      min: 100000000000000000,
      max: 1000000000000000000,
      edit: false,
      isLoading: false,
      fullPage: true,
      referral: {
        client_id: "",
        recipient_facility: "",
        provisional_diagnosis: "",
        treatment_given: "null",
        investigations: "",
        reason: "null",
        name_of_reffering_personnel: "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/diagnosis-agency/407465`)
      .then((response) => {
        this.diseases = response.data.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  computed: {
    randomNumber: function () {
      let authorization_code = Math.floor(
        Math.random() * (this.max - this.min + 1) + this.min
      );
      return authorization_code;
    },
  },
  methods: {
    getProviders() {
      this.axios
        .get(`/api/v1/auth/providerAgency/407465`)
        .then((response) => {
          this.providers = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    searchIDCard() {
      this.isLoading = true;
      this.axios
        .post(`/api/v1/auth/getuserbyIdcard`, {
          id_card_number: this.searchkey,
        })
        .then((response) => {
          this.search_result = response.data;
          console.log(response);
          this.$toasted.info("Searched Successfully", {
            position: "top-center",
            duration: 3000,
          });

          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
          this.$toasted.info("User not Found", {
            position: "top-center",
            duration: 3000,
          });
        });
    },

    clearIt() {
      this.referral.recipient_facility = "";
      this.referral.provisional_diagnosis = "";
      this.referral.treatment_given = "";
      this.referral.investigations = "";
      this.referral.reason = "";
      this.searchkey = "";
    },

    AddReferral() {
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/referrals", {
          name_of_reffering_personnel: this.user.id,
          client_id: this.search_result.type == 'client' ? this.search_result.data.id : 0,
          dependent_id: this.search_result.type == 'dependent' ? this.search_result.data.id : 0,
          agency_id: 407465,
          referring_facility: this.search_result.type == 'client' ?  this.search_result.data.provider_id : this.search_result.data.provider,
          recipient_facility: this.referral.recipient_facility.id,
          provisional_diagnosis: this.referral.provisional_diagnosis.id,
          treatment_given: this.referral.treatment_given,
          investigations: this.referral.investigations,
          reason: this.referral.reason,
        })

        .then((response) => {
          console.log(response);
          this.clearIt();
          this.isLoading = false;
          this.$toasted.info("Referral Submitted Successfully", {
            position: "top-center",
            duration: 3000,
          });
          this.$router.push(`/all-referrals`);
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getProviders();
  },
};
</script>

<style scoped>
.page-header {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  padding-bottom: 40px;
}
.header-icon-wrap {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.form-card {
  border-radius: 12px;
  border: 1px solid #e9ecef;
  overflow: hidden;
}
.form-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
}
.section-number {
  width: 28px;
  height: 28px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  flex-shrink: 0;
  font-size: .78rem;
  font-weight: 700;
}

.form-label { font-weight: 600; font-size: .85rem; color: #374151; margin-bottom: 6px; }

.form-control:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 0.15rem rgba(37, 99, 235, 0.15);
}

.btn-submit {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border: none;
  color: #fff;
  border-radius: 8px;
  font-weight: 600;
  padding: 10px 22px;
}
.btn-submit:hover { opacity: 0.9; color: #fff; }
.btn-submit:disabled { opacity: 0.5; cursor: not-allowed; }
</style>
